<template>
  <div class="card-title py-3">
    <component :is="titleTag" class="ma-0">
      <slot></slot>
    </component>
  </div>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    subtitle: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    titleTag () {
      return this.subtitle ? 'h4' : 'h2'
    }
  }
}
</script>
